import React from 'react'
import img001 from '../components/images/smo.png'
import img001a from '../components/images/audience.jpg'
import img001b from '../components/images/targeted.jpg'
import img001c from '../components/images/realtime.jpg'


const events = () => {
    return (

        <>
            <div className="row  m-2">
                <img src={img001} alt='SMO' />
            </div>
            <div className='container text-center'>
                <h2>Understanding Social Media Marketing (SMM)</h2>
                <p>
                    <b> Social Media Marketing (SMM) </b> is the practice of using social media platforms to promote products, services, or brands. It involves creating and sharing content tailored to the social media environment to achieve marketing and branding goals.
                </p>
            </div>
            <div className='container'>
                <div className='row'>
                    <div className='col'>
                        <p>
                            <b>Audience Engagement: 📱</b><br />
                            SMM focuses on building relationships with audiences through interactive content, including posts, comments, and direct messaging, to foster a community around a brand.
                        </p>
                    </div>
                    <div className='col'>
                        <img src={img001a} alt='Queryimg' />
                    </div>
                </div>

                <div className='row'>
                    <div className='col'>
                        <p>
                            <b>Targeted Advertising 🖋️</b><br />
                            SMM allows for highly targeted and personalized ads based on user demographics, interests, and behaviors, ensuring that marketing efforts reach the most relevant audience.
                        </p>
                    </div>
                    <div className='col'>
                        <img src={img001b} alt='Queryimg' />
                    </div>
                </div>
                <div className='row'>
                    <div className='col'>
                        <p>
                            <b>Real-Time Analytics: 📊</b><br />
                            It provides immediate feedback on the effectiveness of marketing campaigns through metrics such as likes, shares, comments, and clicks, enabling quick adjustments and optimization.
                        </p>
                    </div>
                    <div className='col'>
                        <img src={img001c} alt='Queryimg' />
                    </div>
                </div >

            </div>
        </>
    )
}

export default events